// src/seo/BecomePublisherSEO.js
import { SEO_CONFIG } from './SEOConfig';

export const BecomePublisherSEOData = {
    title: `Publish Your Book | നിങ്ങളുടെ പുസ്തകം പ്രസിദ്ധീകരിക്കൂ`,
    description: "Publish your Malayalam book with Uyirmozhy. We handle editing, proofreading, cover design, ISBN, printing, and marketing on Amazon & Flipkart.",
    keywords: "book publishing Kerala, Malayalam book publishers, self publishing India, ISBN registration, book printing service, Uyirmozhy",
    url: `${SEO_CONFIG.baseUrl}/become-publisher`,

    // Schema for a "Service" (Book Publishing)
    schema: {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Book Publishing",
        "provider": {
            "@type": "Organization",
            "name": SEO_CONFIG.orgName,
            "url": SEO_CONFIG.baseUrl,
            "logo": SEO_CONFIG.baseSchema.logo
        },
        "description": "Complete book publishing services including editing, design, ISBN, printing, and distribution on Amazon/Flipkart.",
        "areaServed": {
            "@type": "Country",
            "name": "India"
        },
        "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Publishing Services",
            "itemListElement": [
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Proofreading & Editing" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Cover Design & Typesetting" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ISBN Registration" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Printing & Binding" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Online Distribution (Amazon/Flipkart)" } }
            ]
        }
    }
};